import AppLoader from 'Components/AppLoader';
import { useUserEffect } from 'Components/Authorize/guardHelpers';
import { connect } from 'react-redux';

import { getRedirectURLLocalStorage, loadPage } from '../../../helpers';

const GuestOnlyGuard = ({ redirectRoute, user, fallback, children, path, url }) => {
  useUserEffect();
  if (user?.logged) {
    if (fallback) {
      return fallback;
    }
    const newPath = getRedirectURLLocalStorage();
    loadPage(url.replace(path, newPath ?? redirectRoute));
  }

  if (user?.sessionChecked) {
    return children;
  }

  return <AppLoader />;
};

export default connect(({ user }) => ({ user }))(GuestOnlyGuard);
